import { z } from 'zod';

export const promotionSchema = z.object({
  name: z
    .string()
    .min(1, 'validation.required')
    .min(3, 'validation.minLength')
    .max(100, 'validation.maxLength'),
  code: z
    .string()
    .min(1, 'validation.required')
    .min(3, 'validation.minLength')
    .max(50, 'validation.maxLength')
    .regex(/^[A-Z0-9_-]+$/i, 'Code must contain only letters, numbers, underscores, or hyphens'),
  type: z
    .enum(['percentage', 'fixed', 'free_shipping', 'buy_x_get_y']),
  value: z
    .number()
    .min(0, 'validation.positiveNumber'),
  minPurchase: z
    .number()
    .min(0, 'validation.positiveNumber')
    .optional(),
  maxDiscount: z
    .number()
    .min(0, 'validation.positiveNumber')
    .optional(),
  usageLimit: z
    .number()
    .int()
    .min(0, 'validation.positiveNumber')
    .optional(),
  startDate: z
    .string()
    .min(1, 'validation.required'),
  endDate: z
    .string()
    .min(1, 'validation.required'),
  isActive: z
    .boolean()
    .default(true),
  applicableProductIds: z
    .array(z.string())
    .optional(),
  applicableCategoryIds: z
    .array(z.string())
    .optional(),
});

export type PromotionFormData = z.infer<typeof promotionSchema>;
